module.exports = {
  returnName: {
    1: 'Celular',
    2: 'Residencial',
  },
  returnNameForName: {
    Celular: 'Celular',
    Residencial: 'Residencial',
  },
};
